import Route from '@ember/routing/route';

import type { LibraryClientsEditModel } from '../../client';

export type LibraryClientsEditHomeModel = LibraryClientsEditModel;

export default class LibraryClientsClientEditHomeRoute extends Route {
  controllerName = 'library.clients.client.edit';

  model(): LibraryClientsEditHomeModel {
    const baseModel = this.modelFor(
      'library.clients.client.edit'
    ) as LibraryClientsEditModel;

    return baseModel;
  }
}
